export default {
  getDiasSemana(state) {
    return state.diasSemana;
  },
  getHorarios(state) {
    return state.horarios;
  },
  getHorariosMeiaHora(state) {
    return state.horariosMeiaHora;
  },
  getDiaSemana(state) {
    return (diaAsNumber) => state.diasSemana
      .find((diaSemana) => diaSemana.value === diaAsNumber).label;
  },
};
